import {Button, Link, Theme, useMediaQuery} from '@material-ui/core';
import {makeStyles, useTheme} from '@material-ui/styles';
import clsx from 'clsx';
import React, {useEffect, useState} from 'react';
import {Footer} from './Footer';
import {Sidebar} from './Sidebar';
import {Topbar} from './Topbar';
import UserEdit from '../../views/Users/UserEdit';
import ResendVerifyEmailModal from '../../views/Users/ResendVerifyEmailModal';
import {getMe} from '../../graphql/auth';
import logoutUser from './logoutUser.api';
import {ContactUsBar} from '../ContactUsBar';
import InfoModal from '../../views/BookingTool/InfoModal';
import {T} from 'react-polyglot-hooks';
import {getHost} from '../../graphql/GraphQlProvider';
import {BillingParty, BillingPartyMember} from '../../graphql/billing_party.datatypes';
import PaymentCheckoutFrame from '../../views/Payments/PaymentCheckoutFrame';
import ContactUs from '../../components/ContactUs';
import useRouter from 'use-react-router';
import billingParty from "../../views/BookingTool/Step4BillingDetails/BillingParty";

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 84,
    height: '100%',
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    height: '100%'
  }
}));

const Main = (props: { children: any }) => {
  const { children } = props;
  const { history } = useRouter();

  const classes = useStyles();
  const theme: Theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  const userData = getMe();
  const loggedIn = !!(userData.data && userData.data.me);
  const user = userData.data!.me;

  const [sendLogoutUser] = logoutUser();
  const handleLogout = () => sendLogoutUser();

  const [openEdit, setOpenEdit] = useState(false);
  const [openVerifyEmail, setOpenVerifyEmail] = useState(false);
  const [openSoftCancelled, setOpenSoftCancelled] = useState<{ count: number, open: boolean, billingParty?: BillingParty, billingPartyMember?: BillingPartyMember }>({
    count: 0,
    open: false
  });
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [contactUsModal, setContactUsModal] = React.useState(false);

  const [allMembersCancelled, setAllMembersCancelled] = useState() ;

  useEffect(() => {
    if (loggedIn && user.onetime_password && !openEdit) {
      setOpenEdit(true);
    } else if (loggedIn && !openEdit && !openVerifyEmail && !user.email_verified) {
      setOpenVerifyEmail(true);
    } else if (loggedIn && !openEdit && !openVerifyEmail && user) {
      let softCancelledCount = 0;
      let billingParty: BillingParty | undefined;
      let billingPartyMember;
      if (user.billingPartyMembers) user.billingPartyMembers.map((member) => {
        if (member.billingParty && member.billingParty.soft_cancelled) {
          softCancelledCount += 1;
          billingParty = {...member.billingParty};
          billingPartyMember = {...member};

        }
          setAllMembersCancelled(
              (billingParty && billingParty.cancelled_members && billingParty.cancelled_members.length > 0) &&
              (billingParty && billingParty.members && billingParty.members.length === 0)
          );
      });
      if (!openSoftCancelled.open && softCancelledCount > 0) {
        setOpenSoftCancelled({billingParty, billingPartyMember, count: softCancelledCount, open: true});
      }
    }
  }, [userData]);

  return (
      <React.Fragment>
      <div
          className={clsx({
            [classes.root]: true,
            [classes.shiftContent]: isDesktop
          })}
      >
        <Topbar onSidebarOpen={handleSidebarOpen}/>
        <Sidebar
            onClose={handleSidebarClose}
            open={shouldOpenSidebar}
            variant={isDesktop ? 'persistent' : 'temporary'}
        />
        <main className={classes.content}>
          {children}
          <Footer/>
        </main>

        {openEdit && <UserEdit self confirmEmail user={userData.data!.me} onClose={() => setOpenEdit(false)} open={true}/>}
        {!openEdit && openVerifyEmail && <ResendVerifyEmailModal onLogout={() => handleLogout()} open={true}/>}
        {openSoftCancelled.open && !contactUsModal && !openPaymentModal && (
            <InfoModal open={true} title=" We’re Sorry, Your Reservation was Cancelled"
                       body={
                         openSoftCancelled.count === 1 ?
                             'Your payment is 14 days past due. Our team has not heard from you and therefore, your reservation has been cancelled. If you would like to be reinstated, please make a payment, using the “Make a Payment” button below. Total Due: $' + openSoftCancelled.billingParty!.overduePayments :
                             'One of your payments is 14 days past due. Our team has not heard from you and therefore, your reservation has been cancelled. If you would like to be reinstated, please contact us to speak to a representative.'+(openSoftCancelled.billingParty && ' Total Due: $' + openSoftCancelled.billingParty.overduePayments)
                       }
                       action={[
                         openSoftCancelled.count === 1 && <Button key={1} onClick={() => setOpenPaymentModal(true)} variant="contained" disabled={allMembersCancelled}>
                           <T phrase="Make a Payment"/>
                         </Button>,
                         <Button key={2} onClick={() => setContactUsModal(true)} variant="contained">
                           <T phrase="Contact Us"/>
                         </Button>,
                         openSoftCancelled.count === 1 && <Link key={3}  href={getHost() + '/invoice/' + openSoftCancelled.billingParty!.code}>
                           <Button variant="contained"><T phrase="Download Invoice"/></Button>
                         </Link>,
                         <Button key={4} onClick={() => handleLogout()} variant="contained">
                           <T phrase="Logout"/>
                         </Button>,
                       ]}/>
        )}

        {openPaymentModal && openSoftCancelled.billingParty && openSoftCancelled.billingPartyMember && (
            <PaymentCheckoutFrame
                onClose={() => setOpenPaymentModal(false)}
                onSuccess={() => {
                  setOpenPaymentModal(false);
                  setOpenSoftCancelled({open: false, count: 0});
                  userData.refetch().then(() => {
                    history.push('/dashboard?refresh=true');
                  });
                }}
                open={true}
                billingPartyId={openSoftCancelled.billingParty.id}
                billingPartyMemberId={openSoftCancelled.billingPartyMember.id}
                amount={openSoftCancelled.billingParty.overduePayments}
            />
        )}

        {contactUsModal && openSoftCancelled.billingParty &&  (
            <ContactUs
                onClose={() => setContactUsModal(false)}
                open={true}
                groupId={openSoftCancelled.billingParty.booking!.group_id}
                heading={'Contact us'}
                message="Please let us know how we can help."
                adminMessage={'Billing party ' + openSoftCancelled.billingParty!.id + ' soft cancelled query.'}
            />
        )}

      </div>
      <ContactUsBar />
      </React.Fragment>
  );
};

export default Main;
